import { 
		DAY_NAMES,
		MONTH_NAMES,
		ONE_DAY,
		UTILITY_CSS_CLASSES,
		LONG_MONTHS,
		DELETE_SUCCESS_FADEOUT_DURATION,
		EDIT_MSG_FADEOUT, 
		GRACEFUL_FINALLY_DELAY
} from './constants.js';

function propOrEmpty(prop, fallBack='') {
    return prop ? prop : fallBack;
}


function isAFunction(callback={}) {
    return ( typeof callback === 'function' );
}

export function needToPluralize(number) {
	return ( number > 1 )
}

/*
* Begin Date functions
*/

export function pluralizeDays(str, number) {
	return ( needToPluralize(number) ? str + "s" : str ); 
} 

export function getDateProp(tempDate, prop) {
	var date = new Date(tempDate);
	var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    var yShort = y.toString().substr(2,2);
    var toReturn = -1;
    var hours = date.getHours();
    var minutes = date.getMinutes();
	var seconds = date.getSeconds();

    if ( prop === 'day' ) {
    	// toReturn = (d <= 9 ? '0' + d : d);
    	toReturn = (d);
    } else if ( prop === 'dayName' ) {
		const options = {weekday: "short"};
		toReturn = new Intl.DateTimeFormat("en-US", options).format(tempDate);
    } else if ( prop === 'month' ) {
    	toReturn = (m<=9 ? '0' + m : m);
    } else if ( prop === 'monthName' ) {
    	toReturn = MONTH_NAMES[m-1] != undefined ? MONTH_NAMES[m-1] : -1;
	} else if ( prop === 'monthNameShort' ) {
    	toReturn = MONTH_NAMES[m-1] != undefined ? MONTH_NAMES[m-1] : -1;
		toReturn  = toReturn.substr(0, 3);
    } else if ( prop === 'year' ) {
    	toReturn = y;
    } else if ( prop == 'yearShort' ) {
    	toReturn = yShort;
    } else if ( prop == "time" ) {
		const amPM = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12;
		minutes = minutes.toString().padStart(2, '0');
    	toReturn = `${hours}:${minutes}${amPM}`;
    } else if ( prop == "timeMilitary" ) {
		hours = hours.toString().padStart(2, '0');
		minutes = minutes.toString().padStart(2, '0');
    	toReturn = `${hours}:${minutes}`;
    } else if ( prop == "fullDate" ) {
		hours = hours.toString().padStart(2, '0');
		minutes = minutes.toString().padStart(2, '0');
		seconds = seconds.toString().padStart(2, '0');

		d = d.toString().padStart(2, '0');
		m = m.toString().padStart(2, '0');

		toReturn = `${y}-${m}-${d}T${hours}:${minutes}:${seconds}`;
	} else if ( prop === "date" ) {
		d = d.toString().padStart(2, '0');
		m = m.toString().padStart(2, '0');
		toReturn = `${y}-${m}-${d}`;
	} else if ( prop === "yearMonth" ) {
		// m = MONTH_NAMES[m-1] != undefined ? MONTH_NAMES[m-1] : -1;
		m = m.toString().padStart(2, '0');
		toReturn = `${y}-${m}`;
	}
    return toReturn;
}

export function formatDate(tempDate) {
	var date = new Date(tempDate);
	var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    return ' ' + (m<=9 ? '0' + m : m) + ' ' + (d <= 9 ? '0' + d : d);
}

export function formatTodoItemDate(tempDate) {
	var monthFirst = true;

	if ( monthFirst ) {
		return getDateProp(tempDate, "monthName") + " " + getDateProp(tempDate, "day");	
	}
    return getDateProp(tempDate, "day") + " " + getDateProp(tempDate, "monthName");
}

export function formatDateForTasks(tempDate) {
	const dateStr = `${getDateProp(tempDate, "dayName")}  ${getDateProp(tempDate, "monthName")}  ${getDateProp(tempDate, "day")}`;	

	return dateStr;
}

export function dateIsToday(date) {
	var today = new Date();

	if ( !(date instanceof Date) ) {
		date = new Date(date);
	}
	
	return date.getDate() == today.getDate() &&
		date.getMonth() == today.getMonth() &&
		date.getFullYear() == today.getFullYear();
}

export function datePassed(tempDate) {
	if ( !tempDate  ) {
		return false;
	}
	var date = new Date(tempDate);
	var today = new Date();
	return date < today && !dateIsToday(tempDate);
}

export function dateApproaching(date) {
	var today = new Date();
	return date > today;
}

export function getDateWeekNumber(tempDate) {
	var oneJan =  new Date(tempDate.getFullYear(), 0, 1);   
	var numberOfDaysInAYear =  Math.floor((tempDate - oneJan) / (24 * 60 * 60 * 1000));   
	var tempDateWeekNumber = Math.ceil(( tempDate.getDay() + 1 + numberOfDaysInAYear) / 7);    
   return tempDateWeekNumber;
}

export function getToDoItemDateProps(date) {
	let today = new Date();
	let currentYear = today.getFullYear();
	let currentMonth = today.getMonth();
	let currentDay = today.getDate();
	let currentWeekNumber = getDateWeekNumber(today); 

	let tempDate = new Date(date);
	let tempDateYear = tempDate.getFullYear();
	let tempDateMonth = tempDate.getMonth();
	let tempDateDay = tempDate.getDate();
	let tempDateWeekNumber = getDateWeekNumber(tempDate); 
	let dateFormated = formatTodoItemDate(date);

  	// let dayDiff = Math.abs(tempDateDay - currentDay);
  	let todayTempDateDiff = (today  - tempDate);
  	let dayDiff = Math.ceil(todayTempDateDiff / ONE_DAY)
  		dayDiff = Math.abs(dayDiff) ;

  	let monthDiff = tempDateMonth - currentMonth;
  	let weekDiff = tempDateWeekNumber - currentWeekNumber;
  	let daysRemaining = dayDiff;
	let priorityStr = "gray";

	let renderTime = false;
	let renderYear = true;

	let dueDateClass = "due-date ";
	let modifierClass = '';

	let inTwoWeeks = false;
	let inAWeek = false;
	let isToday = dateIsToday(date);

	const passed = datePassed(date);

	
	// console.log("weekDiff " + weekDiff + ", dayDiff " , + dayDiff + ", dateFormated " +  dateFormated);
	if ( tempDateYear  <= (currentYear + 1) ) { // within 1 year

		if ( tempDateYear == currentYear ) { // same year
			if ( weekDiff > 4 ) {
				priorityStr = "black";
			} else {
				if ( dayDiff <= 7 ) { // within 1 week  <= 1
					priorityStr = "red";
					renderTime = true;
					inAWeek = true;
					renderYear = false;
				} else if ( dayDiff <= 14) {
					priorityStr = "orange";
					renderTime = true;
					inTwoWeeks = true;
					renderYear = false;
				} else if ( dayDiff <= 21 ) {
					priorityStr = "yellow";
				} else {
					priorityStr = "blue";
				}
			}
		} 
	}
	// if ( dateIsToday(date) ) {
	// 	dateFormated = "Today";	
	// 	priorityStr = "red";
	// }

	if ( !passed ) {
		if ( inAWeek ) {
			if ( isToday ) {
				modifierClass = UTILITY_CSS_CLASSES.dateToday;
			} else {
				modifierClass = UTILITY_CSS_CLASSES.dateApproaching;
			}
		}
	} else {
		modifierClass = UTILITY_CSS_CLASSES.datePassed;
	}
	

	if ( !passed ) {
		dueDateClass += priorityStr;
	} else {
		dueDateClass += "passed";
	}
	return {
			class: dueDateClass,
			priorityStr: priorityStr,
			modifierClass: modifierClass,
			renderTime: renderTime, 
			dateFormated: dateFormated,
			inToWeeksPlus: !inTwoWeeks && !inAWeek, 
			inTwoWeeks: inTwoWeeks,
			inAWeek: inAWeek,
			isToday: isToday,
			year: getDateProp(tempDate, 'year'),
			yearShort: getDateProp(tempDate, 'yearShort'),
			month: getDateProp(tempDate, 'monthName'),
			day: getDateProp(tempDate, 'day'),
			time: getDateProp(tempDate, 'time'),
	};
}

export function calculateDateDifference(laterDate = undefined, earlierDate) {
	let laterDateObj; 
	if ( laterDate === undefined ) {
		laterDateObj = new Date();
	} else {
		laterDateObj = new Date(laterDate);
	}
	
	let earlierDateObj = new Date(earlierDate);

	return Math.abs(laterDateObj.getTime() - earlierDateObj.getTime());
}

export function calculateDateDifferenceFromNow(date1) {
	return calculateDateDifference(undefined, date1)
}

export function calculateDaysDifferenceFromNow(date1) {
	return ( Math.ceil(calculateDateDifferenceFromNow(date1) / (1000 * 60 * 60 * 24)) ); 
}

export function datesOnTheSameDay(date1Str='', date2Str='') {
	const date1 = new Date(date1Str);
	const date2 = new Date(date2Str);

	if (date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()) {

		return true;
	} 

	return false;
}

export function timeStampToDateTimeLocal(dateStr) {
	// if ( typeof dateStr !== 'string' ) return false;
	return getDateProp(dateStr, 'fullDate');
}

// Converts date into yyyy-MM-dd format
export function timeStampToDate(dateStr) {
	return getDateProp(dateStr, 'date');
}

export function monthIsLong(month=-1) {
	return LONG_MONTHS.indexOf(month) !== -1;
}

export function isLeapYear(year) {
	if ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) {
		return true;
	} else {
		return false;
	}
}

export function getStreakDateProps(date) {
	const dateProps = {
			fullDate: date,
			day: getDateProp(date, "day"), 
			month: parseInt(getDateProp(date, "month")),
			year: getDateProp(date, "year")
	}

	dateProps.longMonth = monthIsLong(dateProps.month);
	dateProps.isLeapYear = isLeapYear(dateProps.year);

	let numberOfDays = dateProps.longMonth ? 31 : 30;

	if (  dateProps.month === 2 && !dateProps.isLeapYear ) {
		numberOfDays = 28;
	}

	dateProps.numberOfDays = numberOfDays;

	return dateProps;
}

export function calculateDifferenceBetweenDates(date1, prevDate, returnDiffs=false) {
	let oneDayApart = false;
	const date1Props = getStreakDateProps(date1);
	const prevDateProps = getStreakDateProps(prevDate);
	
	const numberOfDays =  date1Props.day > prevDateProps.day ? date1Props.numberOfDays : prevDateProps.numberOfDays;	
	const yearDiff = Math.abs(date1Props.year - prevDateProps.year);
	const monthDiff = ( yearDiff * 12 ) + ( date1Props.month - prevDateProps.month );
	
	const daysDiff = Math.abs(date1Props.day - prevDateProps.day);
	const dayDiff =  Math.abs( ( monthDiff * numberOfDays ) - (daysDiff) );

	const sameMonth = monthDiff == 0;

	const diffs = { 
			date1: date1Props, 
			prevDate: prevDateProps, 
			yearDiff:  yearDiff, 
			monthDiff: monthDiff, 
			daysDiff: daysDiff, 
			dayDiff: dayDiff, 
			sameMonth: sameMonth
	}

	if ( dayDiff !== -1 || monthDiff > 1 || yearDiff > 1 ) {
		oneDayApart = false;
	}

	oneDayApart = dayDiff === 1;
	diffs.oneDayApart = oneDayApart;

	if ( returnDiffs ) {
		console.log('diffs', diffs);
		return diffs;
	}

	return oneDayApart;
}

export function areDatesOneDayApart(date1, prevDate) {
	let oneDayApart = false;
	const date1Props = getStreakDateProps(date1);
	const prevDateProps = getStreakDateProps(prevDate);
	
	const numberOfDays =  date1Props.day > prevDateProps.day ? date1Props.numberOfDays : prevDateProps.numberOfDays;	
	const yearDiff = Math.abs(date1Props.year - prevDateProps.year);
	const monthDiff = ( yearDiff * 12 ) + ( date1Props.month - prevDateProps.month );
	const daysDiff = Math.abs(date1Props.day - prevDateProps.day);
	const dayDiff =  Math.abs( ( monthDiff * numberOfDays ) - (daysDiff) );

	if ( dayDiff !== -1 || monthDiff > 1 || yearDiff > 1 ) {
		oneDayApart = false;
	}

	oneDayApart = dayDiff === 1;

	return oneDayApart;
}

export function streakDateUnitTests() {

	const tests = new Map();

	// New year case: true
	const date1a = '2026-01-01 11:22:59';
	const date1b = '2025-12-31 11:22:59';
	const diff1 = calculateDifferenceBetweenDates(date1a, date1b, true);
	const result1 = diff1.oneDayApart;

	// true
	const date2a = '2025-09-18 12:50:51';
	const date2b = '2025-09-17 10:02:35';
	const diff2 = calculateDifferenceBetweenDates(date2a, date2b, true);

	// false
	const date3a = '2025-09-18 12:50:51';
	const date3b = '2025-09-15 10:02:35';
	const diff3 = calculateDifferenceBetweenDates(date3a, date3b, true);
	
	
	// false
	const date4a = '2025-09-18 12:50:51';
	const date4b = '2025-08-17 10:02:35';
	const diff4 = calculateDifferenceBetweenDates(date4a, date4b, true);
	
	// true
	const date5a = '2025-09-01 12:50:51';
	const date5b = '2025-08-31 10:02:35';
	const diff5 = calculateDifferenceBetweenDates(date5a, date5b, true);

	// true
	const date6a = '2025-10-01 12:50:51';
	const date6b = '2025-09-30 12:50:51';
	const diff6 = calculateDifferenceBetweenDates(date6a, date6b, true);

	// March 31 - Jan 1 --> false
	const date7a = '2025-03-31 12:50:51';
	const date7b = '2025-01-01 12:00:00';
	const diff7 = calculateDifferenceBetweenDates(date7a, date7b, true);
	
	// 1 - 30 (on a 31 month) -> false
	const date8a = '2025-06-01 12:00:00';
	const date8b = '2025-05-30 12:00:00';
	const diff8 = calculateDifferenceBetweenDates(date8a, date8b, true);

	// Feb edge case --> true
	// leap year: false
	const date9a = '2025-03-01 12:00:00';
	const date9b = '2025-02-28 12:00:00';
	const diff9 = calculateDifferenceBetweenDates(date9a, date9b, true);
	
	// Feb edge case --> false
	// leap year: true
	const date10a = '2024-03-01 12:00:00';
	const date10b = '2024-02-28 12:00:00';
	const diff10 = calculateDifferenceBetweenDates(date10a, date10b, true);
	
	
	//  Dec 31 - Nov 1 --> false
	const date11a = '2025-12-31 12:00:00';
	const date11b = '2024-11-01 12:00:00';
	const diff11 = calculateDifferenceBetweenDates(date11a, date11b, true);
	
	// Jan 2 - Dec 31 --> false
	const date12a = '2026-01-02 12:00:00';
	const date12b = '2025-12-31 12:00:00';
	const diff12 = calculateDifferenceBetweenDates(date12a, date12b, true);
	
	
	// Mar 1, 25 - Feb 28, 25 --> true
	const date13a = '2025-03-01 12:00:00';
	const date13b = '2025-02-28 12:00:00';
	const diff13 = calculateDifferenceBetweenDates(date13a, date13b, true);

	tests.set(diff1, true);
	tests.set(diff2, true);
	tests.set(diff3, false);
	tests.set(diff4, false);
	tests.set(diff5, true);
	tests.set(diff6, true);
	tests.set(diff7, false);
	tests.set(diff8, false);
	tests.set(diff9, true);
	tests.set(diff10, false);
	tests.set(diff11, false);
	tests.set(diff12, false);
	tests.set(diff13, true);

	let i = 0 ;
	tests.forEach((expectedResult, diff) => {
		const result = diff.oneDayApart;

		if ( result !== expectedResult ) {
            console.log(`i:${i} ${diff} valid? result: ${result} expected: ${expectedResult} %cFAIL`, 'color: red;');
        } else {
            console.log(`i:${i} ${diff} valid? result: ${result} expected: ${expectedResult} %cPASS`, 'color: green;');
        }

		i++;
	})
}

export function streakDatesUnitTest2(habits=[]) {
	const tests = new Map();
	// id: 1 --> 3
	// id: 2 --> 2
	// id: 7 --> 2
	// id: 3 --> 2
	// id: 4 --> 1
	// id 9 --> 1
	// id: 10 --> 3
	// id: 61 --> 1

	tests.set(1, 3);
	tests.set(2, 2);
	tests.set(7, 2);
	tests.set(3, 2);
	tests.set(4, 1);
	tests.set(9, 2);
	tests.set(10, 3);
	tests.set(61, 2);
	tests.set(64, 0);

	console.log("habits", habits);

	habits.forEach(habit => {
		const habitID = habit.getId();
		const result = habit.getCurrentStreak();
		const expectedResult = tests.get(habitID);

		if ( result !== expectedResult ) {
            console.log(`id:${habitID} | ${habit.getTitle()} valid? result: ${result} expected: ${expectedResult} %cFAIL`, 'color: red;');
        } else {
            console.log(`id:${habitID} | ${habit.getTitle()} valid? result: ${result} expected: ${expectedResult} %cPASS`, 'color: green;');
        }
	});
}

export function timeTravel(date, direction="prev", daysToStep=1) {
	if ( daysToStep < 0 ) {
		return false;
	}
	const currentDate = new Date(date);
	const targetDate = new Date(date);

	if ( direction === "prev" ) {
		targetDate.setDate(currentDate.getDate() - daysToStep);
	} else {
		targetDate.setDate(currentDate.getDate() + daysToStep);
	}	

	return targetDate;
}

export function convertDatePickerValueToLocal(value='2025-09-25') {
	const valueWithTimeZone = `${value}T00:00`
	return new Date(valueWithTimeZone);
}

export function calculateDurationBetweenDates(laterDate, earlierDate, fullReturn=false) {
	if ( earlierDate > laterDate ) {
		const tempDate = earlierDate;
		earlierDate = laterDate;
		laterDate = tempDate;
	}
	const diff = calculateDateDifference(laterDate, earlierDate);
	const inSeconds = diff / 1000;
	const inMinutes = diff / (1000 * 60);
	const inHours = diff / (1000 * 60 * 60);

	if ( fullReturn ) {
		return {
				inMilliseconds: diff,
				inSeconds: inSeconds,
				inMinutes: inMinutes, 
				inHours, inHours 
		};
	}

	return diff;
}

export function addDurationToDate(startDate=new Date(), durationMill=-1) {
	let newDate = startDate;
	let startDateObj = startDate;
	
	if ( typeof startDate === 'string' ) {
		startDateObj = new Date(startDate);
		newDate = startDateObj;
	}	

	const startDateMill = startDateObj.getMilliseconds();
	newDate.setMilliseconds(startDateMill + durationMill);
	return newDate;
}

// Returns the first and last day of targetDate's month as a range
export function getMonthDateRange(targetDate = new Date()) {
	if ( !targetDate || !(targetDate instanceof Date)) {
		return false;
	}

	let firstDay = new Date(targetDate.getFullYear(), targetDate.getMonth(), 1);
	let lastDay = new Date(targetDate.getFullYear(), targetDate.getMonth() + 1, 0);

	firstDay = getDateProp(firstDay, 'date');
	lastDay = getDateProp(lastDay, 'date');

	return {
		date_start: firstDay,
		date_end: lastDay,
	}
}

// Returns the first day and last day of current month as a range
export function getCurrentMonthDateRange() {
	return getMonthDateRange(new Date());
}

// Returns today's date formatted for month picker
export function initializeMonthPicker() {
	return getDateProp(new Date(), "yearMonth");
}

// Checks if dateRanges are equal
// dateRange1, dateRange2 must be in the following format:
// { date_start: '2026-09-01', date_end: '2026-09-30'}
export function dateRangesAreEqual(dateRange1=false, dateRange2=false) {
	if ( !dateRange1 || !dateRange2 ) {
		return false;
	}

	if ( !dateRange1.date_start || !dateRange1.date_end  || !dateRange2.date_start || !dateRange2.date_end ) {
		return false;
	}

	return dateRange1.date_start === dateRange2.date_start &&
			dateRange1.date_end === dateRange2.date_end;
}


/* 
* End Date functions
*/

export function calculateTrackerProgress(daysDone, goal) {
	let dateDeltaDays = daysDone;
	let percentage = calculateProgressPercentage(dateDeltaDays, goal);
	let circlePercentageDelta = 200 - percentage;
	let circlePercentage = circlePercentageDelta;

	return {'days' : dateDeltaDays, 
			'percentage': percentage, 
			'circlePercentage': circlePercentage
	};
}

export function calculateProgressPercentage(deltaDays, goal) {
    return ( ( ( deltaDays ) / goal ) * 100 ).toFixed(1);
}

export function calculateRepsFromDate(reps, coefficient, dateDeltaDays) {
	return Math.ceil( reps + (dateDeltaDays * coefficient) );
}

export function calculateCircleDegreeFromPercentage(percentage=0.0) {
	return Math.ceil( 3.6 * percentage );
}

export function makeBEM(parentClass='', childClass='') {
    return `${parentClass}__${childClass}`;
}

export function calculatePercentage(number1=0, number2=0) {
	if ( number1 === 0 || number2 === 0  ) {
		return 0;
	} 

	if ( isNaN(number2) ) {
		number2 = parseFloat(number2);
	}

	const ratio = number1 / number2;
	const percentage = Math.ceil( ratio * 100 );

	return percentage;
}

export function usernameInputValid(input='') {
	 if ( input === '' ) {
		return false;
	}
	
	const isValid = /^[a-zA-Z-0-9]*$/g.test(input);
	return isValid;
}

export function passwordInputValid(input='') {
	if ( input === '' ) {
		return false;
	}

	return true;
}

export function numberInputValid(input='') {
	if ( input === '' ) {
		return false;
	}
	
	const isValid = /^[0-9]*$/g.test(input);
	return isValid;
}

export function titleInputValid(input='') {
	if ( input === '' ) {
		return false;
	}

	const isValid = /^[a-zA-Z-'0-9 ]*$/g.test(input);
	return isValid;
}


export function getBoardTypeIcon(type='') {
	let iconName= 'plus';

	switch(type) {
		case 'Notes':
			iconName = 'notes';
			break;
		case 'Workouts':
			iconName = 'progress-circle';
			break;
		case 'Habits':
			iconName = 'habits';
			break;
		case 'ToDo':
			iconName = 'todo';
			break;
		case 'Tasks':
			iconName = 'tasks';
			break;
		case 'Budget': 
			iconName = 'budget';
			break;
		default:
			break;
	} 
	return iconName;
}

export function getSettingTypeIcon(type='') {
	let iconName= 'notes';

	switch(type) {
		case 'Boards':
			iconName = 'boards';
			break;
		case 'General':
			iconName = 'settings';
			break;
		default:
			break;
	} 
	return iconName;
}

export function roundNumberToCurrency(amount=0) {
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'decimal',
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
	});

	return formatter.format(amount);
}

export function onIOSWebView() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIos = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
    const isStandalone = navigator.standalone;

    return isIos && !isSafari && !isStandalone;
}

export function onIOSWebApp() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	const isIos = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
	const isStandalone = navigator.standalone;

	return isIos && isStandalone;
}


// Checks if on Safari browser and not on iOSWebApp
export function onSafari() {
	const isSafari = 
			navigator.vendor && 
			navigator.vendor.indexOf('Apple') > -1 && 
			navigator.userAgent && 
			navigator.userAgent.indexOf('CriOS') == -1 && 
			navigator.userAgent.indexOf('FxiOS') == -1;
	return isSafari && !onIOSWebApp();

}

export function fadeOutThenExecute(callbackFn=false) {
	if ( typeof callbackFn !== 'function' || !callbackFn ) {
		return false;
	}

	return setTimeout(() => {
		callbackFn();
	}, DELETE_SUCCESS_FADEOUT_DURATION);
}

export function fadeOutFormMsg(callbackFn=false, nextMsg='') {
	setTimeout(() => {
		callbackFn( nextMsg );
	}, EDIT_MSG_FADEOUT);
}

export function getDefaultFormMsg(editMode=false, editMsg='', defaultMsg='', ) {
	return editMode ?
            editMsg :
            defaultMsg;
}

export function displayAmountWithUnit(amount=-1, unit=false, unitSuffix=false) {
	if ( !unit ) {
		return amount;
	}

	return `${!unitSuffix ? unit : ''}${amount}${ unitSuffix ? unit : ''}`;
}

export function gracefulFinally(callbackFn=false) {
	if ( !callbackFn ) {
		return false;
	}
	setTimeout(() => {
		callbackFn(false);
	}, GRACEFUL_FINALLY_DELAY);
}

export function convertBoardTypeToClass(boardType='') {
	if ( !boardType || typeof boardType !== 'string' ) {
		return false;
	}

	return boardType.toLocaleLowerCase();
}

export function generateRandomNumber(upperLimit=1000) {
	if ( !upperLimit || upperLimit <= 1 ) {
		return -1;
	} 
	return Math.floor ( Math.random() * upperLimit ) + 1;
}

export {
    propOrEmpty,
    isAFunction,
};
